/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 11:26:42
 * @LastEditTime: 2020-11-19 11:15:59
 */
const monitorDevice = {
  state: {
    deviceGroup: {}, // 设备分组id
  },
  mutations: {
    // 设置deviceGroupId
    SETGROUP(state, group) {
      state.deviceGroup = group
    },
  },
  actions: {
    setGroup({ commit }, group) {
      commit('SETGROUP', group)
    }
  }
}
export default monitorDevice